{
  "display-rr-1": {
    "slot": "/22280732/bltzgg_dapp_lol_other_300x250_atf_rr1",
    "sizes": [[300, 250]]
  },
  "display-rr-2": {
    "slot": "/22280732/bltzgg_dapp_lol_other_300x250_atf_rr2",
    "sizes": [[300, 250]]
  },
  "display-rr-3": {
    "slot": "/22280732/bltzgg_dapp_lol_other_300x250_atf_rr3",
    "sizes": [[300, 250]]
  },
  "display-lr-1": {
    "slot": "/22280732/BLTZGG_DESKTOP_ROS_LR1",
    "sizes": [[300, 600], [160, 600], [300, 250]]
  },
  "display-desktop-anchor": {
    "slot": "/22280732/BLTZGG_DESKTOP_ANCHOR_728x90",
    "sizes": [[728, 90]]
  },
  "display-desktop-anchor-infeed": {
    "slot": "22280732/BLTZGG_DESKTOP_ROS_ANCHOR_INFEED_728x90",
    "sizes": [[728, 90]]
  },
  "display-skin": {
    "slot": "/22280732/CPMStar_Skin",
    "safeFrame": false,
    "sizes": [[1, 1]]
  }
}
